const customFormatters: Record<
  string,
  {
    type: 'addCached';
    fn: (
      lng: string | undefined,
      options: unknown
    ) => (value: unknown) => string;
  }
> = {
  format_error_id: {
    type: 'addCached',
    fn: () => (v) =>
      typeof v === 'string' && /^\d+$/.test(v)
        ? ` (0x${(~~v).toString(16).toUpperCase()})`
        : '',
  },
};

export default customFormatters;
